<template>
    <div class="customer_details">
        <div class="top clearfix">
          <div>
            <div class="pic">
                <img src="@static/images/yhtx.png" alt="">
            </div>
            <div class="naph">
                <span class="name">{{policyerName}}</span>
                <span class="phone">手机号：{{phone2}}</span>
            </div>
            <div class="ormn">
                <span class="order">累计保单：{{totalPolicyNum}}单</span>
                <span class="money">累计保费：{{totalFee}}元</span>
            </div>
          </div>
          <div>
            <el-button class="back-btn" @click="back()">返回</el-button>
          </div>
        </div>
        <div class="bdta">
            <div class="bdtitle"><i></i><span>客户保单</span></div>
            <el-table  class="omtable" ref="singleTable" border :stripe='true' :data="tableData" style="width: 100%" tooltip-effect="dark">
                <el-table-column type="index" fixed="left"></el-table-column>
                <el-table-column property="insuranceName" min-width="160px" label="投/被保人姓名" :show-overflow-tooltip="true">
                    <template slot-scope="scope">{{scope.row.policyerName}}-{{scope.row.insuranceName}}</template>
                </el-table-column>
                <el-table-column property="createTime" label="创建时间" min-width="170px;" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime|timeSubstr(0,16)}}</span>
                    </template>
                </el-table-column>
                <el-table-column property="productName" label="产品名称" min-width="260px;" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="fee" label="保费（元）" min-width="100px" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="mechanShortName" label="所属机构" min-width="240px" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="policyNo" label="保单号" min-width="200px;" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="状态" min-width="100px;" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{all.POLICY_STATUS[scope.row.policyStatus]}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="page" background layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size='10' :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
//当前实例组件

export default {

  data: () => ({
    data:'',
    select:'',
    labelPosition:'right',
    tableData: [],
    phone1:'',
    phone2:'',
    totalFee:'',
    totalPolicyNum:'',
    policyerName:'',
    total:0
  }),
  components: {

  },
  created() {
     this.phone1 = this.$route.query.phone1;
     this.phone2 = this.$route.query.phone2;
     this.totalFee = this.$route.query.totalFee;
     this.totalPolicyNum = this.$route.query.totalPolicyNum;
     this.policyerName = this.$route.query.policyerName;
     this.getState();
  },
  methods: {
    back(){
      history.go(-1);
    },
    //获取状态
    getState:function(){
        var that = this;
        this.$tools.getall(that.setAll);
    },
    setAll:function(data){
        this.all = data;
        this.gettableData(1);
    },
    gettableData: function(num) {
        var that = this;
        this.$http({
            url: '/master/policy/getMyPolicys',
            type: 'put',
            params: {
                asc: false,
                orderBy: "id",
                pageNum: num,
                pageSize: 10,
                policyerMobile1:that.phone1,
                policyerName:that.policyerName
            },
        }).then(function(data) {
            that.tableData = data.data.page.data;
            that.total = data.data.page.total
        })
    },
    handleCurrentChange:function(val){
        this.gettableData(val)
    }
  },
  mounted() {

  }
};
</script>
<style lang="scss">
@import "~@/sass/pages/customer_details";
</style>
